import ImageGallery from 'react-image-gallery';
import React from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';
import { GalleryContainer } from './galleryContainer';

export const Gallery = (props) => (
  <GalleryContainer>
    <ImageGallery {...props} />
  </GalleryContainer>
);
